import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter, Inject,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {ModalService} from '../../../services/modal.service';
import {IMessengerConnector, Message} from '../../../types/all.type';
import {InterfaceService} from '../../../services/interface.service';
import {SenderService} from '../../../services/sender.service';
import {Subject, Subscription, takeUntil, throttleTime} from 'rxjs';
import {TelegramService} from '../../../pages/page-telegram/telegram.service';
import {filter} from 'rxjs/operators';
import {log} from '../../../functions';
import {AppService} from '../../../services/app.service';
import {DcService} from '../../../services/dc.service';

@Component({
  selector: 'app-message-sender',
  templateUrl: './message-sender.component.html',
  styleUrls: ['./message-sender.component.scss', '../message/message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageSenderComponent implements OnInit, OnDestroy {
  @Input() message: Message;
  @Input() index: number;
  @Input() Service: IMessengerConnector;
  @Output() onEditMessage = new EventEmitter<any>();
  @Output() onToggleMessage = new EventEmitter<any>();
  @Output() contextMenuOpen = new EventEmitter<any>();
  percent: any = 0;
  successPercent: any = 0;
  private destroy$: Subject<void> = new Subject();

  constructor(
    private dcService: DcService,
    public appService: AppService,
    public telegramService: TelegramService,
    public modalService: ModalService,
    private cd: ChangeDetectorRef,
    public interfaceService: InterfaceService,
    public senderService: SenderService
  ) {
  }

  ngOnInit(): void {
    this.cd.detach();

    this.getPercent();
    this.cd.detectChanges();

    this.senderService.updateMessage$.pipe(filter((v) => v.id === this.message.id), takeUntil(this.destroy$)).subscribe((message: Message) => {
      Object.keys(message).forEach((key) => {
        this.message[key] = message[key];
      });
      this.getPercent();
      // log('updateMessage$', this.message);
      this.cd.detectChanges();
    });
    this.dcService.detectChanges$.pipe(filter((event) => event === 'message' || event === 'message-' + this.message.id), takeUntil(this.destroy$))
      .subscribe((event) => {
        this.cd.detectChanges();
      });
  }

  /*updateMessage(): Subscription {
    const timeout = this.generateRandomIntegerInRange(10000, 30000);
    return this.senderService.updateMessage(this.message.id).subscribe((message) => {
      Object.keys(message).forEach((key) => {
        this.message[key] = message[key];
      });
      if (this.message.sender.completed) {
        this.updateSubscribe.unsubscribe();
      }
      this.getPercent();
      this.cd.detectChanges();
      this.updateTimeout = setTimeout(() => {
        this.updateSubscribe = this.updateMessage();
      }, timeout);
    }, error => {
      setTimeout(() => {
        this.updateSubscribe = this.updateMessage();
      }, 60000);
    });
  }*/

  generateRandomIntegerInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  getPercent() {
    let current_count = this.message.sender?.current_count;
    if (!this.isParse) {
      let totalSend: number = this.totalSend;
      let errorCount: number = this.errorCount;
      if (this.isLoop) {
        totalSend = this.message.sender?.loop_need_count * this.message.sender.total_send;
        current_count = (this.message.sender?.loop_count * this.message.sender.total_send + this.message.sender?.current_count);
        errorCount = this.message.sender?.loop_count * this.fatalCount;
      }
      if (this.isCompleted) {
        this.percent = 100;
        this.successPercent = 100;
      } else {
        this.percent = ((current_count * 100) / totalSend).toFixed(2);
        this.successPercent = (100 - ((errorCount * 100) / totalSend)).toFixed(2);
        // console.log('!!!!', current_count, this.message.sender, 'errorCount', errorCount, 'totalSend', totalSend, this.percent, this.successPercent, 'current_count', current_count)
      }

    } else {
      if (this.isCompleted) {
        if (!this.message.sender.text) {
          this.percent = 100;
          this.successPercent = 100;
        } else {
          this.percent = (10 + ((current_count * 90) / this.totalSend)).toFixed(2);
          // console.log('!!!', ((current_count * 90) / this.totalSend), this.totalSend, current_count)
          this.successPercent = (((current_count - this.errorCount) * 90) / this.totalSend).toFixed(2);
        }

      } else {
        const parsedPercent = ((this.message.sender.parsed_count * 100) / this.message.sender.parsed_members_count);
        this.percent = (parsedPercent / 10).toFixed(2);
      }
    }
    if (this.successPercent >= 100) {
      // this.color = {'0%': '#00959c', '100%': '#52c41a'};
    }

  }

  get color(): any {
    if (this.lastError === 'PEER_FLOOD_LIMIT') {
      return {'100%': '#d08b0e', '0%': '#e0a400'};
    } else if (this.lastError) {
      return {'100%': '#FF4500', '0%': '#8B0000'};
    } else if (this.isCompleted) {
      return {'0%': '#52c41a', '100%': '#52c41a'};
    } else if (this.isBanned) {
      return {'100%': '#00959c', '0%': '#EC5800'};
    } else if (this.isPause) {
      return {'100%': '#ffc107', '0%': '#faad14'};
    }
    return {'0%': '#108ee9', '50%': '#2db7f5', '100%': '#52c41a'};
  }

  get isFoodWait(): boolean {
    return this.message.sender?.last_error?.includes('FLOOD_WAIT:');
  }

  get isPercentFoodWait(): boolean {
    return this.message.sender?.last_error?.includes('PERCENT_FLOOD_ACCOUNTS:');
  }

  get floodWaitTime(): number {
    if (this.isFoodWait) {
      const timeWait = this.message.sender.last_error.split('FLOOD_WAIT:')[1];
      return Math.abs(Math.round((parseInt(timeWait, 10) - new Date().getTime() / 1000) / 60));
    }
    return 0;
  }

  get fatalCount(): number {
    const arFatals = JSON.parse(this.message.sender?.contacts_fatal || '[]');
    return Object.keys(arFatals)?.length;
  }

  get errorCount(): number {
    return this.message.sender.error_count || 0;
  }

  get currentSendCount(): number {
    return this.message.sender.current_count;
  }

  get totalSend(): number {
    if (this.isParse) {
      return this.message.sender?.parsed_count;
    } else {
      return this.message.sender?.total_send;
    }
  }

  get lastError(): string {
    return this.message.sender?.last_error || this.lastParseError;
  }

  get lastParseError(): string {
    return this.message.sender?.parsed_status;
  }

  get isCompleted(): boolean {
    return this.message.sender?.completed;
  }

  get isPause(): boolean {
    return this.message.sender?.pause;
  }

  get isBanned(): boolean {
    return this.message.sender?.is_banned;
  }

  get isCompletedDate(): boolean {
    return !!this.message.sender?.end_date && this.message.sender.start_date != this.message.sender.end_date;
  }

  get isLoop(): boolean {
    return this.message.sender?.loop_need_count > 1;
  }
  get isPost(): boolean {
    return this.message.sender?.type === '2' || this.message.sender?.type === 2;
  }
  get isParse(): boolean {
    return this.message.sender?.type === '3' || this.message.sender?.type === 3;
  }

  get isParseNotFound(): boolean {
    return this.message.sender.parsed_status === 'PEER_ID_INVALID' || this.message.sender.parsed_status === 'USERNAME_INVALID';
  }

  get isParsingCompleted(): boolean {
    return this.message.sender?.parsed_completed;
  }
  get status(): {load: boolean, text: string, icon: string, icon_class: string, tooltip?: string, time?: number} {
      if (!this.lastError && !this.isPause && !this.isBanned && this.message.sender?.current_count === 0 && !this.isCompleted) {
        const targetDate: Date = new Date(this.message.sender.start_date);
        const currentDate: Date = new Date();
        if (targetDate > currentDate) {
          return {
            tooltip: 'Вы установили время старта',
            load: true,
            icon: '',
            icon_class: '',
            time: targetDate.getTime(),
            text: 'Ожидается запуск '
          };
        } else {
          return {
            tooltip: 'Обычно запуск занимает до 5 мин. после начала даты запуска.',
            load: true,
            icon: '',
            icon_class: '',
            text: 'Ожидание запуска...'
          };
        }

      }

      if (this.isCompleted && !this.lastError) {
        return {
          load: false,
          icon: 'check',
          icon_class: 'text-success',
          text: 'Завершено'
        };
      }else if (this.isPause && !this.lastError) {
        return {
          load: false,
          icon: 'pause',
          icon_class: 'text-warning',
          text: 'На паузе'
        };
      }else if (this.lastError) {
        if (this.isParse && this.isParseNotFound) {
          return {
            load: false,
            icon: 'alert-triangle',
            icon_class: 'text-warning',
            text: 'Чат/канал для парсинга не найден'
          };
        }else{
        }
      }
      return undefined;
  }

  get attachmentsCount(): number {
    if (!this.message.sender?.attachments) {
      return 0;
    }
    try {
      const attachments = JSON.parse(this.message.sender?.attachments);
      return Object.keys(attachments)?.length;
    } catch (e) {
      return 0;
    }
  }

  get textsCount(): number {
    if (!this.message.sender?.text_variations) {
      return 0;
    }
    try {
      return JSON.parse(this.message.sender?.text_variations)?.length;
    } catch (e) {
      return 0;
    }
  }

  openDetailInfo() {
    const clearContact = this.telegramService.clearContact(this.message.sender.parsed_chat);
    this.modalService.openModal('ModalChatDetailComponent', {
      Service: this.telegramService,
      id: clearContact,
      type: 'user'
    });
  }
  addAccount(): void {
    this.interfaceService.addAccount(this.Service);
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected readonly menubar = menubar;
}
